import styled from "styled-components";
import TypographyComponent from "@material-ui/core/Typography";

export const DisabledTypography = styled(TypographyComponent)`
  ${({ theme }) => `
    color: ${theme.palette.text.disabled};
  `}
`;
